import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  contractTypeList,
  removeContractTypeMutation,
} from '../../shared/queries/ContractTypes';

const ContractTypes = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const { t, history, dispatch } = props;

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadAllContractTypes = () => {
    const query = contractTypeList();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        setData(res.contractTypeListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = removeContractTypeMutation(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        loadAllContractTypes();
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/tipo-contrato/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/tipo-contrato/mnt/${rowData.id}`);
  };

  useEffect(() => {
    loadAllContractTypes();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onRefreshClick={loadAllContractTypes}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('screens.mnt_tipo_contratos.title')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

ContractTypes.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ContractTypes)
);
